export default{
    getService: function(item,msg){
        switch(item.KeyId){
          case '149':
            if(item.NameCHS != '' ){
                msg.hint += item.NameCHS
            }
            else if(item.NameEN != '' ){
                msg.hint += item.NameEN
            }
            break
          case '119':
            if(item.NameCHS != '' ){
                msg.hint += item.NameCHS
            }
            else if(item.NameEN != '' ){
                msg.hint += item.NameEN
            }
            break
          case '120':
            if(item.NameCHS != '' ){
                msg.hint += item.NameCHS
            }
            else if(item.NameEN != '' ){
                msg.hint += item.NameEN
            }
            break

          case '215':
            if(item.NameCHS == 'True'){
                msg.wifi = '客房Wifi：有，' 
            }
            else{
                msg.wifi = '客房Wifi：无，'
            }
            break 

          case '214':
            if(item.NameCHS == 'True'){
                msg.band = '宽带：有'
            }
            else{
                msg.band = '宽带：无'
            }

            break 

          case '41':
            if(item.NameCHS == 'True'){
                msg.park = '有'
            }
            else{
                msg.park = '无'
            }
            break 

          case '42':
            if(msg.park == '有'){
                if(item.NameCHS == 'True'){
                    msg.park += ' 收费'
                }
                else{
                    msg.park += ' 免费'
                }
            }
            break

          case '44':
            if(msg.park == '有'){
                if(item.NameCHS != ''){
                    msg.park += item.NameCHS
                }
            }
            break
          case '189':
            if(item.NameCHS == 'True'){
                msg.selfservicemachine = '有'
            }
            else{
                msg.selfservicemachine = '无'
            }
            break 
          case '123':
          if(item.NameCHS == 'True' && msg.food.substring(0,2) == '有餐厅'){
            msg.food += ' 午餐'
          }
          break

          case '124':
          if(item.NameCHS == 'True' && msg.food.substring(0,2) == '有餐厅'){
            msg.food += ' 晚餐'
          }
          break

          case '125':
          if(item.NameCHS=='True' && msg.food.substring(0,2) == '有餐厅'){
            msg.food += ' 其他餐'
          }
          break

          case '50':
          if(item.NameCHS=='True'){
            msg.food = '早餐 '
            msg.bf = '提供早餐服务,早餐形式为'
          }
          else{
            msg.bf = '无早餐服务'
          }
          break 

          case '51':
          if(item.NameCHS=='True'){
            msg.food = '有餐厅，提供：' + msg.food
          }
          else{
           msg.food = '无餐厅'
          }
          break 

          case '52':
          if(msg.bf != '无早餐服务'){
            if(item.NameCHS == '0'){
                msg.bf += '自助，'
            }
            else if(item.NameCHS == '1'){
                msg.bf += '套餐，'
            }
            else{
                msg.bf += '其他，'
            }
          }
          break 

          case '151':
            if(msg.bf != '无早餐服务'){
                msg.bf += '早餐价格为' + item.NameCHS + ' 元/人，'
            }
          break 

          case '243':
            if(msg.bf != '无早餐服务'){
                msg.bf += '早餐服务时间为' + item.NameCHS + ' ~ '
            }
          break 

          case '244':
            if(msg.bf != '无早餐服务'){
                msg.bf +=  item.NameCHS 
            }
          break 

          case '152':
            if(item.NameCHS == 'True'){
                msg.conRoom = '有会议室' + msg.conRoom
            }
            else{
                msg.conRoom = '无会议室'
            }
          break 

          case '53':
            if(item.NameCHS != ''){
                msg.conRoom += '，共有' + item.NameCHS + '个会议室' 
            }
          break 

          case '54':
            if(item.NameCHS != ''){
                msg.conRoom += '，分别容纳' + item.NameCHS + '人' 
            }
          break 

          case '55':
            if(item.NameCHS != ''){
                msg.conRoom += '，收费标准：' + item.NameCHS  
            }
          break 

          case '62':
            if(item.NameCHS == 'True'){
                msg.laundry = '有洗衣室'
            }
            else{
                msg.laundry = '无洗衣室'
            }
          break 

          case '63':
          if(msg.laundry == '有洗衣室'){
              if(item.NameCHS == '0'){
                msg.laundry += '，自助洗衣' 
              }
              else{
                msg.laundry += '，代送洗衣'
              }
          }
          break 

          case '64':
          if(msg.laundry == '有洗衣室'){
            msg.laundry += item.NameCHS 
          }
          break 

          case '70':
            if(item.NameCHS == 'True'){
                msg.luggage = '有' 
            }
            else{
                msg.luggage = '无'
            }
          break 

         case '91':
            if(item.NameCHS == 'True'){
                msg.forGue = '可以' 
            }
            else{
                msg.forGue = '暂不可以'
            }
          break 

         case '92':
            if(item.NameCHS == 'True'){
                msg.unionPay = '银联' 
            }
            else{
                msg.unionPay = '不支持银行卡支付'
            }
          break 

         case '93':
            if(item.NameCHS == 'True'){
                msg.unionPay += '，Visa' 
            }
          break 

          case '94':
            if(item.NameCHS == 'True'){
                msg.unionPay += '，Master' 
            }
          break 

          case '95':
            if(item.NameCHS == 'True'){
                msg.unionPay += '，JCB' 
            }
          break 

          case '96':
            if(item.NameCHS == 'True'){
                msg.unionPay += '，Diners' 
            }
          break 

          case '97':
            if(item.NameCHS == 'True'){
                msg.unionPay += '，AME' 
            }
          break 
          
          case '117':
            if(item.NameCHS == 'True'){
                msg.facilities[0] = '、分体空调' 
            }
          break 

          case '108':
            if(item.NameCHS == 'True'){
                msg.facilities[1] = '、独立卫生间' 
            }
          break 

          case '109':
            if(item.NameCHS == 'True'){
                msg.facilities[2] = '、24小时热水' 
            }
          break 
        }
    },
    //判断是否能使用特殊发票
    canUseSpecial(list){
        for(var i in list){
            var type = list[i].Infokey
            if(type == '-2' || type == '-3'){
                return true
            }
        }
        return false
    },
    serviceIcon:input =>  {
        switch(input){
            case '41':
                return 'parking'
            case '215':
                return 'wifi'
            case '152':
            //会议室
                return 'other'
            case '51':
                  return 'food'
            case '91':
                return 'other'
            case '-1':
                return 'pp'
            case '-2':
                return 'zp3'
            case '-3':
                return 'zp6'
            case '189':
                return 'selfservice'
            default :
                return 'other'
                break
            }
    },
    //依据评分获取文字:差，一般，好，很好，非常好
    scoreDisplay: input =>{
        if(input <= 1){
            return '差'
        }
        else if(input <= 2){
            return '一般'
        }
        else if(input <= 3){
            return '好'
        }
        else if(input <= 4){
            return '很好'
        }
        else{
            return '非常好'
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/hotelService.js